import { Link } from "react-router-dom";
import errorImg from "../../assets/images/error.png";

export default function NotFound () {

  document.title = "Not Found";

  return (
    <div className="not-find">
      <div className="write_box input-type mypage_content box_style1">
        <div className="ms-auto">
          <div className="page-content">
            <h1>404!</h1>
            <h4>경로를 찾을 수 없어요</h4>
            <p>방문하시려는 페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없어요</p>
            <Link className="btn_basic bg2" to="/">뒤로가기</Link>
          </div>
          <div className="page-img">
            <img src={errorImg}alt=""className="img-fluid mx-auto d-block"/>
          </div>
        </div>
      </div>
    </div>
  );
}